import { TrackerActions } from '../actions/actionTypes'
import { TrackerEntryInterface } from '../Interfaces/TrackerEntryInterface'
import { ReducerBuilder } from './ReducerBuilder'

export interface LocalTrackerEntries {
  loaded: boolean
  entries: TrackerEntryInterface[]
}

export interface DeleteResult {
  id: string
  deleted: boolean
}

const setEntries = (state: LocalTrackerEntries, payload: TrackerEntryInterface[]): LocalTrackerEntries => ({
  loaded: true,
  entries: payload,
})

const addEntry = (state: LocalTrackerEntries, payload: TrackerEntryInterface): LocalTrackerEntries => {
  return {
    loaded: true,
    entries: [...state.entries, payload],
  }
}

const updateEntry = (state: LocalTrackerEntries, payload: TrackerEntryInterface): LocalTrackerEntries => {
  const foundIndex = state.entries.findIndex((x) => x.entryId === payload.entryId)
  const copy = [...state.entries]
  copy[foundIndex] = payload
  return {
    loaded: true,
    entries: copy,
  }
}

const deleteEntries = (state: LocalTrackerEntries, payload: DeleteResult[]): LocalTrackerEntries => {
  const copy = state.entries.filter((e) => payload.every((p) => !(p.id === e.entryId && p.deleted)))
  return {
    loaded: true,
    entries: copy,
  }
}

type ReducerType = TrackerEntryInterface[] | TrackerEntryInterface | DeleteResult[]

export default new ReducerBuilder<LocalTrackerEntries, ReducerType>({ loaded: false, entries: [] })
  .mapAction(TrackerActions.CREATE_TRACKER_ENTRY, addEntry)
  .mapAction(TrackerActions.LOAD_TRACKER_ENTRIES, setEntries)
  .mapAction(TrackerActions.UPDATE_TRACKER_ENTRY, updateEntry)
  .mapAction(TrackerActions.DELETE_TRACKER_ENTRIES, deleteEntries)
  .build()
